import stageIcon from "@/icons/content/property/stage.svg";

import {
  defaultCountryConfig as baseDefaultCountryConfig,
  ICountryConfig,
} from "../../country.config";

// Stage-specific country configuration override
const stageCountryConfig: Partial<ICountryConfig> = {
  countries: [
    // Add staging environment
    {
      label: "(preProd) STAGING",
      value: "stage",
      icon: stageIcon,
      code: "stage",
      link: "https://stage.donmajor.com/",
    },
    // Override specific countries with new links and prefixes
    ...baseDefaultCountryConfig.countries.map((country) => {
      switch (country.value) {
        case "Spain":
          return {
            ...country,
            label: "(preProd) " + country.label,
            link: "https://spain.donmajor.com/",
          };
        case "France":
          return {
            ...country,
            label: "(preProd) " + country.label,
            link: "https://france.donmajor.com/",
          };
        case "UAE":
          return {
            ...country,
            label: "(preProd) " + country.label,
            link: "https://dubai.donmajor.com/",
          };
        default:
          // Keep original countries unchanged
          return country;
      }
    }),
  ],
};

export default stageCountryConfig;
